import React from "react";
import { Handle, Position } from "reactflow";
import PropTypes from "prop-types";
import Integrations from "views/Bots/NLP/application/Build/Tabs/Intents/application/Integrations";
import { ElementsCustom } from "@components/Elements";
import { withTranslation } from "react-i18next";
import { useFlowNodes } from "../../../../../context";
import "./IntegrationConfigIntentNode.scss";

const IntegrationConfigIntentNode = ({ t }) => {
  const {
    intent,
    integrations,
    switchboard,
    updateIntent,
    getGroups,
    settings,
    getCustomFields,
    use_custom_fields,
    handleTags,
    zendesk_groups
  } = useFlowNodes();

  return (
    <>
      <Handle type="target" position={Position.Top} />
      <div className="integrations-root">
        <div className="integrations-header">
          <span className="integrations-title">
            {t("common:intents.flow_chat.integrations.title")}
          </span>
        </div>
        <div className={"content"}>
          <div
            className={` ${
                Array.isArray(integrations) && integrations.some(
                (integration) =>
                  integration.channel !== "zendesk_full" ||
                  integration.channel !== "sunco"
              )
                ? "elements-integrations--no-grid elements-integrations"
                : ""
            }`}
          >
            {integrations.some(
              (integration) =>
                integration.channel === "zendesk_full" ||
                integration.channel === "sunco"
            ) && (
              <div className="elements-integrations-zendesk">
                <ElementsCustom
                  t={t}
                  type={"zendesk"}
                  input_type={"input_with_tags"}
                  element_type={"tags"}
                  element={settings?.tags}
                  elements={intent?.tags}
                  updateElement={handleTags}
                />
              </div>
            )}
          </div>
          <div className="integrations-content">
            <Integrations
              t={t}
              zendesk_groups={zendesk_groups}
              intent={intent}
              switchboard={switchboard}
              integrations={integrations}
              updateIntent={updateIntent}
              getGroups={getGroups}
              getCustomFields={getCustomFields}
              use_custom_fields={use_custom_fields}
            />
          </div>
        </div>
      </div>
      <Handle type="source" position={Position.Bottom} />
    </>
  );
};

IntegrationConfigIntentNode.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation(["commons", "common"])(IntegrationConfigIntentNode);
